import React from 'react';
import { API } from '../../config';

const SenderProductsList = ({products}) => (
    <ul className="divide-y divide-gray-200">
        {products.map((product) => (
            <li key={product.id} className="flex py-6 px-4 sm:px-6">
                <div className="flex-shrink-0">
                    <img src={`${API}/static/product_photos/${product.primary_photo}`} alt={product.name} className="w-20 rounded-md" />
                </div>

                <div className="ml-6 flex-1 flex flex-col">
                    <div className="flex">
                        <div className="min-w-0 flex-1">
                            <h4 className="text-sm">
                                    {product.name}
                            </h4>
                            <p className="mt-1 text-sm text-gray-500">{product.size}</p>
                        </div>

                        <div className="ml-4 flex-shrink-0 flow-root">
                            {/* delete button was here */}
                        </div>
                    </div>

                    <div className="flex-1 pt-2 flex items-end justify-between">
                        <p className="mt-1 text-sm font-medium text-gray-900">{product.price}</p>
                    </div>
                </div>
            </li>
        ))}
    </ul>
);

export default SenderProductsList;
